import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { scaleNumber } from "../../../utils/formatNumber";

export function CustomsDocumentStatusCard({
  title,
  displayTitle = "",
  sent = 0,
  outstanding = 0,
  accent = "#1976d2",
  icon: Icon = null,
  sx = {},
}) {
  const total = Number(sent || 0) + Number(outstanding || 0);
  const completion = total > 0 ? (Number(sent || 0) / total) * 100 : 0;
  const hasOutstanding = Number(outstanding || 0) > 0;

  return (
    <Card sx={{ height: "100%", ...sx }}>
      <CardContent sx={{ height: "100%" }}>
        <Stack spacing={1.5}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ minWidth: 0 }}>
            <Stack sx={{ borderLeft: `4px solid ${accent}`, pl: 1.5, minWidth: 0 }}>
              <Tooltip title={title}>
                <Typography variant="body2" color="text.secondary" noWrap>
                  {displayTitle || title}
                </Typography>
              </Tooltip>
              <Typography variant="h5" sx={{ fontWeight: 700 }}>
                {`${Math.round(completion)}%`}
              </Typography>
            </Stack>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: `${accent}1A`,
                color: accent,
              }}
            >
              {Icon ? <Icon fontSize="small" /> : null}
            </Box>
          </Stack>

          <LinearProgress
            variant="determinate"
            value={completion}
            sx={{
              height: 10,
              borderRadius: 5,
              backgroundColor: "#E9EEF5",
              "& .MuiLinearProgress-bar": {
                borderRadius: 5,
                backgroundColor: accent,
              },
            }}
          />

          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            <Chip
              size="small"
              label={`Sent: ${scaleNumber(Number(sent || 0))}`}
              color="success"
              variant="outlined"
            />
            <Chip
              size="small"
              label={`Outstanding: ${scaleNumber(Number(outstanding || 0))}`}
              color={hasOutstanding ? "error" : "success"}
              variant="outlined"
            />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

CustomsDocumentStatusCard.propTypes = {
  title: PropTypes.string.isRequired,
  displayTitle: PropTypes.string,
  sent: PropTypes.number,
  outstanding: PropTypes.number,
  accent: PropTypes.string,
  icon: PropTypes.elementType,
  sx: PropTypes.object,
};
